import { INotifications } from 'modules/Layout';
import { NavigateFunction } from 'react-router-dom';

export const actionOnNavigate = (
  note: INotifications,
  navigate: NavigateFunction
): void => {
  const { notificationEvents, event, tag } = note;
  if (event === 'report') {
    if (tag === 'User Risk') {
      console.log('user risk need to add');
    }
    if (tag === 'Risk Register') {
      navigate('/risk-register');
    }
    if (tag === 'Training Progress') {
      navigate('/training-programs');
    }
    if (tag === 'Dataset Activity') {
      navigate('/datasets');
    }
    if (tag === 'Incident Summary') {
      navigate('/incidents-log');
    }
    if (tag === 'Compliance Posture') {
      navigate('/compliance-tracking');
    }
    if (tag === 'Policy Activity') {
      navigate('/policy-management');
    }
    if (tag === 'Ai Inventory') {
      navigate('/ai-systems');
    }
  }
  if (event === 'policy_approvals' || event === 'policy_approved') {
    navigate(`/policy-management/detail/${notificationEvents.policyId}`, {
      state: { activeTab: 'approval' },
    });
  }
  if (event === 'policy_acknowledgement') {
    navigate(`/policy-management/detail/${notificationEvents.policyId}`, {
      state: { activeTab: 'acknowledgements' },
    });
  }
  if (event === 'team_member_invite') {
    window.open(notificationEvents.acceptLink, 'team_member_invite');
  }
  if (event === 'training_assignment_completed') {
    navigate(
      `/training-programs/view/${notificationEvents.trainingProgramId}`,
      {
        state: { activeTab: 'assessment' },
      }
    );
  }
  if (event === 'external_risk_assessment') {
    window.open(notificationEvents.link, 'external_risk_assessment');
  }
};
